import React from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import Navbar from '../components/Navbar';
import './all.sass';
import { Lightbox } from './lightbox';
import { Footer } from './footer';

const TemplateWrapper = ({ children, location, title, description }) => (
  <StaticQuery
    query={graphql`
      query HeadingQuery {
        site {
          siteMetadata {
            titleTemplate
            defaultTitle
            defaultDescription
          }
        }
      }
    `}
    render={(data) => (
      <div>
        <Helmet
          titleTemplate={data.site.siteMetadata.titleTemplate}
          defaultTitle={data.site.siteMetadata.defaultTitle}
        >
          <html lang="ru" />
          {title && <title>{title}</title>}
          <meta
            name="description"
            content={description || data.site.siteMetadata.defaultDescription}
          />
          <link rel="shortcut icon" type="image/png" href="/img/favicon.png" />
          <meta name="theme-color" content="#fff" />
          <link href="https://fonts.googleapis.com/css?family=PT+Serif:400,700" rel="stylesheet" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title || data.site.siteMetadata.defaultTitle} />
          <meta property="og:url" content="/" />
          <meta property="og:image" content="/img/main.jpg" />
          <meta property="og:locale" content="ru_RU" />
        </Helmet>
        <Navbar />
        <div>{children}</div>
        <Footer />
        {location && location.state && location.state.lightbox && (
          <Lightbox location={location} lightbox={location.state.lightbox} />
        )}
      </div>
    )}
  />
);

export default TemplateWrapper;
